import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FillComponent } from './fill.component';
import { AlertModule } from 'ngx-bootstrap/alert';


@NgModule({
  declarations: [
    FillComponent
  ],
  imports: [
    CommonModule,
    AlertModule.forRoot()
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FillModule { }
